import { render } from "./CreateProjectView.vue?vue&type=template&id=da965496"
import script from "./CreateProjectView.vue?vue&type=script&lang=js"
export * from "./CreateProjectView.vue?vue&type=script&lang=js"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__